<checkout-header [host]="host"
                 (back)="back()"
                 [cart]="cart"
                 [step]="getNextStep()"
                 (next)="next()"
                 [canProceed]="canProceed()"></checkout-header>

<main class="container">

  <h5 class="mt-3"><i class="fa fa-coins"></i>&nbsp;<span i18n>Payment Method</span></h5>
  <p i18n>
      Please select a payment option.
  </p>
  <div class="list-group">
    <a *ngFor="let opt of payment_options" href="#" class="list-group-item list-group-item-action is-clickable"
       [class.active]="cart.payment==opt.slug" (click)="setPayment(opt.slug)">
      <div class="row">
        <div class="col-auto">
          <check-circle [active]="cart.payment==opt.slug"></check-circle>
        </div>
        <div class="col">
          <div class="h6"><i class="{{ opt.icon }}"></i>&nbsp;{{ opt.label }}</div>
          <p class="mb-0">{{ opt.text }}</p>
          <div class="mt-1">
            <discount-entry *ngFor="let entry of opt.discounts"
                            [entry]="entry"></discount-entry>
          </div>
        </div>
      </div>
    </a>
  </div>

  <p class="mt-3" i18n>
      The order won't be sent right away, you can still review it before submitting.
  </p>

  <div class="mt-3 mb-3 row">
    <div class="col-5 text-left">
      <button class="btn btn-secondary" (click)="back()"><i class="far fa-arrow-alt-circle-left"></i>&nbsp;<span i18n>Back</span></button>
    </div>
    <div class="col-7 text-right">
      <next-step-button [step]="getNextStep()" [cart]="cart" (next)="next()"
                        [enabled]="canProceed()"></next-step-button>
    </div>
  </div>

</main>
